import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const UserActions = ({
  user,
  onEdit,
  onDeactivate,
  onActivate,
  onResetPassword,
  onDelete,
  onManagePermissions,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      {/* Edit */}
      <Tooltip title="Edit user">
        <Button
          variant="outlined"
          size="small"
          color="primary"
          onClick={() => onEdit(user)}
          sx={{ minWidth: "40px", padding: "6px", borderRadius: "50%" }}
        >
          <EditIcon />
        </Button>
      </Tooltip>

      {/* Permission Overrides */}
      <Tooltip title="Manage permission overrides">
        <Button
          variant="outlined"
          size="small"
          onClick={() => onManagePermissions?.(user)}
          sx={{
            minWidth: "40px",
            padding: "6px",
            borderRadius: "50%",
            borderColor: "rgba(124,58,237,0.4)",
            color: "#7c3aed",
            "&:hover": {
              borderColor: "#7c3aed",
              backgroundColor: "rgba(124,58,237,0.06)",
            },
          }}
        >
          <AdminPanelSettingsIcon />
        </Button>
      </Tooltip>

      {/* Reset Password */}
      <Tooltip title="Reset password">
        <Button
          variant="outlined"
          size="small"
          color="secondary"
          onClick={() => onResetPassword(user.Username)}
          sx={{ minWidth: "40px", padding: "6px", borderRadius: "50%" }}
        >
          <LockResetIcon />
        </Button>
      </Tooltip>

      {/* Delete */}
      <Tooltip title="Deactivate user">
        <Button
          variant="outlined"
          size="small"
          color="error"
          onClick={() => onDelete(user.Username)}
          sx={{ minWidth: "40px", padding: "6px", borderRadius: "50%" }}
        >
          <DeleteForeverIcon />
        </Button>
      </Tooltip>
    </Box>
  );
};

export default UserActions;
